<template>
    <div class="droplayer icon filter-box task-home-b relative">
        <v-menu offset-y :close-on-content-click="false" v-model="filterShow">
            <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" :class="filterCount > 0 ? 'sel' : ''">필터</v-btn>
            </template>
            <div class="dropdown-list cnt board">
                <div class="dropdown-list_header">
                    <span>{{ $i18nUtil.trans("search.filter.001","{cnt}건 선택", {cnt: filterCount}) }}</span>
                    <button type="button" class="btn-refresh" v-if="filterCount > 0" @click="filterClear">새로고침</button>
                </div>
                <div class="cnt_inner clear">
                    <div class="cnt-option">
                        <div class="tit">{{ $i18nUtil.trans("message.filter.003","상세 옵션") }}</div>
                        <ul>
                            <li 
                                v-for="(categoryGradeItem, categoryGradeItemIndex) in categoryGradeList"
                                :key="categoryGradeItem.gradeCode + '_' + categoryGradeItemIndex"
                            >
                                <input type="checkbox" name="" 
                                :id="`chkCategoryGradeId`+categoryGradeItemIndex" 
                                v-model="selectedCategoryGradeCodeList"
                                :value="categoryGradeItem.gradeCode"
                                /><label :for="`chkCategoryGradeId`+categoryGradeItemIndex">{{categoryGradeItem.gradeName}}</label>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="cnt-editor">
                        <div class="tit">생성자</div>
                        <ul>
                            <li><input type="checkbox" name="" id="all2"><label for="all2">전체</label></li>
                            <li><input type="checkbox" name="" id="na1me1"><label for="na1me1">김한화</label></li>
                            <li><input type="checkbox" name="" id="na1me2" checked><label for="na1me2">이생명이이생명이</label></li>
                            <li><input type="checkbox" name="" id="na1me3"><label for="na1me3">김한화</label></li>
                            <li><input type="checkbox" name="" id="na1me4"><label for="na1me4">이생명이이생명이</label></li>
                            <li><input type="checkbox" name="" id="na1me5"><label for="na1me5">이생명이이생명이</label></li>
                            <li><input type="checkbox" name="" id="na1me6"><label for="na1me6">김한화</label></li>
                            <li><input type="checkbox" name="" id="na1me7"><label for="na1me7">이생명이이생명이</label></li>
                        </ul>
                    </div> -->
                </div>
                <div class="dropdown-list_foot">
                    <button type="button" class="btn-primary-small" @click="recoverFilter">{{ $i18nUtil.trans("button.filter.cancel","취소") }}</button>
                    <button type="button" class="btn-primary-small black" @click="applyFilter">{{ $i18nUtil.trans("button.filter.apply","적용") }}</button>
                </div>
                <!-- <div class="info">필터는 중복 선택이 가능합니다.</div> -->
            </div>
        </v-menu>
    </div>
</template>

<script>
export default {
    props:["initFilter"],
    data() {
        return {
            show: false,
            filterCount: 0,
            filterShow: false,
            filterApply: false,
            selectedCategoryGradeCodeList : [],
            prevSelectedCategoryGradeCodeList : [],
            categoryGradeList: [
                {gradeCode: 'NORMAL', gradeName: this.$i18nUtil.trans("entity.category.docGrade.NORMAL","전체공개")}
                , {gradeCode: 'SECRET', gradeName: this.$i18nUtil.trans("entity.category.docGrade.RESTRICT","멤버만 공개")}
                // , {gradeCode: 'SECRET', gradeName: '비공개'}
            ],
        };
    },
    watch:{
        filterShow: {
            handler() {
                let obj = this;
                setTimeout(()=> {
                    if(!obj.filterShow && !obj.filterApply) {
                        obj.selectedCategoryGradeCodeList = obj.prevSelectedCategoryGradeCodeList;
                    }
            
                    if(obj.filterApply) {
                        obj.filterApply = false;
                    }
                }, 50);
            }
        },
        selectedCategoryGradeCodeList: {
            handler() {
                this.filterCount = this.selectedCategoryGradeCodeList.length;
            }
        },
        initFilter:{
            handler(){
                let obj = this; 
                if(obj.initFilter.gradeCodeList.length != 0){ /*  && initFilter.gradeCodeList.length != obj.boardGradeList.length */
                    this.selectedCategoryGradeCodeList = this.initFilter.gradeCodeList;
                    this.prevSelectedCategoryGradeCodeList = this.initFilter.gradeCodeList;
                }
                this.filterShow = false;
                this.filterApply = true;
            }
        }
    },
    methods:{
        // 필터 새로고침
        filterClear() {
            let obj = this;
            obj.selectedCategoryList = [];
            obj.selectedCategoryGradeCodeList = [];
        },
        // 필터 취소
        recoverFilter() {
            let obj = this;
            // 필터 되돌림
            obj.selectedCategoryGradeCodeList = obj.prevSelectedCategoryGradeCodeList;
            obj.filterShow = false;
            obj.filterApply = false;
        },
        // 필터 적용
        applyFilter() {
            let obj = this;
            // 필터 변경
            obj.prevSelectedCategoryGradeCodeList = obj.selectedCategoryGradeCodeList;
            obj.filterShow = false;
            obj.filterApply = true;
            let rtnSelectedCategoryGradeCodeList = obj.selectedCategoryGradeCodeList.length == 0 ? [] : obj.selectedCategoryGradeCodeList;
            
            if(obj.selectedCategoryGradeCodeList.length == 0) {
                obj.categoryGradeList.forEach((elem)=> {
                    rtnSelectedCategoryGradeCodeList.push(elem.gradeCode);
                });
            }
            obj.$emit('updateCommonFilterHomeB', {filterGradeList: rtnSelectedCategoryGradeCodeList});
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/common/filter/CommonFilterHomeB.vue